/**
 * For a given hex color return the color that offers the highest contrast.
 * Based on MIT licensed work by Chris Ferdinandi and Brian Suda https://24ways.org/2010/calculating-color-contrast/
 * @param hexColor A hex color value to calculate the contrast for
 * @param lightHexColor A hex color value to use on dark backgrounds
 * @param darkHexColor A hex color value to use on light backgrounds
 * @returns `lightHexColor` or `darkHexColor` — whichever has the highest contrast against `hexColor`.
 */
export const getContrastingColor: (
  hexColor: string,
  lightHexColor: string,
  darkHexColor: string,
) => string = (
  hexColor: string,
  lightHexColor: string,
  darkHexColor: string,
) => {
  // If a leading # is provided, remove it
  if (hexColor.slice(0, 1) === '#') {
    hexColor = hexColor.slice(1);
  }

  // If a three-character hexcode, make six-character
  if (hexColor.length === 3) {
    hexColor = hexColor
      .split('')
      .map((hex) => hex + hex)
      .join('');
  }

  // Convert to RGB value
  const r = parseInt(hexColor.substr(0, 2), 16);
  const g = parseInt(hexColor.substr(2, 2), 16);
  const b = parseInt(hexColor.substr(4, 2), 16);

  // Get YIQ ratio
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  // Check contrast
  return yiq >= 128 ? darkHexColor : lightHexColor;
};
